import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import * as $ from 'jquery';
import { Canvg } from 'canvg';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cms-sub-fsocial',
  templateUrl: './cms-sub-fsocial.component.html',
  styleUrls: ['./cms-sub-fsocial.component.css']
})
export class CmsSubFSocialComponent {
  fSocialObj = new CmsFooterSocialProperties();
  ValidateFileFormat: boolean;
  constructor(private router: Router, private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }

  public progress: number;
  public message: string;
  public imagePath: any;
  public responseMessage: string;
  ssvgurl: string;
  UpdateFileImage: string = "";
  createFileImage: any;
  uploadedstatus: boolean = false;
 
  ngOnInit() {
    this.LoadEditableData();

  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {

        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0 || sr != undefined) {
          document.querySelector(".updatemain").classList.remove('update_section');
          this.userService.getFooterSocialById(sr).subscribe((data) => {
            this.fSocialObj = data[0] as CmsFooterSocialProperties;
            this.ssvgurl = this.fSocialObj.icons;

            localStorage.removeItem("serialNo");
          });
        }
        else {
          document.querySelector(".createmain").classList.remove('create_section');
        }

      }
      else {
        document.querySelector(".createmain").classList.remove('create_section');
      }
      
    }
    catch (e) {
      //console.log(e);
    }
  }


  createSubSocial() {
    var formData = new FormData();
    formData.append("imagename", this.createFileImage);
    formData.append("socialLinks", this.fSocialObj.socialLinks);
    formData.append(this.UpdateFileImage, this.fSocialObj.icons)
    this.userService.createFooterSocial(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');

      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
    });
  }

 
  onSubmit() {
    if (this.fSocialObj.icons.length === 0) {
      return;
    }
    this.createSubSocial();
    ////console.log(this.imagePath);
  }

  cancel() {
    this.router.navigateByUrl('/cms');
  }
  validateFileType(fileName): boolean {

    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "svg" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
      //TO DO
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }


  onFileclick(event) {
    this.ssvgurl = "";
    const files = event.target.files;
    this.UpdateFileImage = event.target.files[0].name;
    this.fSocialObj.icons= event.target.files[0];
    if (files.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {

        this.ssvgurl = "";
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
   
  }


  UpdateSocial() {
  
    this.UpdateSubSocial();
  }
  UpdateSubSocial() {
    var formData = new FormData();
    formData.append("sr", (this.fSocialObj.sr).toString());
    formData.append("socialLinks", this.fSocialObj.socialLinks);
    formData.append("iconsName", this.fSocialObj.iconsName);
    formData.append("imagename", this.UpdateFileImage);
    formData.append(this.UpdateFileImage, this.fSocialObj.icons)
    this.userService.updateFooterSocial(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');

      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
    });
  }
 


  onFileChangedCreate(event) {
    this.ssvgurl = "";
    const filess = event.target.files;

    this.createFileImage = event.target.files[0].name;
    this.fSocialObj.icons  = event.target.files[0];
    if (filess.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = filess[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
       
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {


        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
   
  }


}
